import { StyledFlex } from '@dreryk/react-components';

import { usePatientDependenciesContext } from '../../dependencies';

import { StyledPatientVisitsHistory } from './PatientVisitsHistory.styled';

type PatientVisitsHistoryProps = {
   readonly patientId: number;
};

export const PatientVisitsHistory = (props: PatientVisitsHistoryProps): JSX.Element => {
   const {
      visitHistoryPanel: { VisitsHistoryInfiniteList, AnnulledVisitsPreferenceVisibilityCheckbox },
   } = usePatientDependenciesContext();

   return (
      <StyledPatientVisitsHistory direction={'column'} gap={'12px'}>
         <StyledFlex justifyContent={'flex-end'}>
            <AnnulledVisitsPreferenceVisibilityCheckbox />
         </StyledFlex>
         <VisitsHistoryInfiniteList patientId={props.patientId} />
      </StyledPatientVisitsHistory>
   );
};
